import { render, staticRenderFns } from "./ArtistSearch.vue?vue&type=template&id=39b19eeb&scoped=true"
import script from "./ArtistSearch.vue?vue&type=script&lang=js"
export * from "./ArtistSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b19eeb",
  null
  
)

export default component.exports